import { Injectable } from "@angular/core";
import { HttpOrdasClientService } from "./http-ordas-client.service";
import { Observable } from "rxjs";
import { tap } from "rxjs/operators";

@Injectable()
export class OrdasService {
  constructor(private http: HttpOrdasClientService) {}

  public getInsuranceUnits(car_year, brand_id): Observable<any> {
    const options = {
      params: {
        car_year,
        brand_id,
      },
    };
    return this.http
      .get("/api/insurances/units", options)
      .pipe(tap((_) => console.log("OrdasService.getInsuranceUnits: Ok")));
  }

  public getBrands(condition, year): Observable<any> {
    const options = {
      params: {
        condition,
        year,
      },
    };
    return this.http
      .get("/api/insurances_express/brands", options)
      .pipe(tap((_) => console.log("OrdasService.getBrands: Ok")));
  }

  public getSubBrands(condition, year, brand_id): Observable<any> {
    const options = {
      params: {
        condition,
        year,
        brand_id,
      },
    };
    return this.http
      .get("/api/insurances_express/sub_brands", options)
      .pipe(tap((_) => console.log("OrdasService.getSubBrands: Ok")));
  }

  public getVersions(condition, year, brand_id, sub_brand_id): Observable<any> {
    const options = {
      params: {
        condition,
        year,
        brand_id,
        sub_brand_id,
      },
    };
    return this.http
      .get("/api/insurances_express/versions", options)
      .pipe(tap((_) => console.log("OrdasService.getVersions: Ok")));
  }

  public quoteUnitInsurances(
    condition,
    term,
    price,
    boa,
    unit_type,
    postal_code,
    product,
    address?,
    load_type?
  ): Observable<any> {
    const options = {
      condition,
      term,
      price,
      boa,
      unit_type,
      postal_code,
      product,
      address,
      load_type,
    };
    return this.http
      .post("/api/insurances_express/quote_unit", options)
      .pipe(tap((_) => console.log("OrdasService.quoteUnitInsurances: Ok")));
  }

  public getInsurances(brand, sub_brand, car_year, is_new, price, ordas_id_vehiculo = null): Observable<any> {
    const options = {
      params: {
        brand_id: brand,
        sub_brand_id: sub_brand,
        car_year: car_year,
        new_or_used: is_new ? "auto_nuevo" : "auto_usado",
        price: price,
      },
    };
    if (ordas_id_vehiculo) options.params["ordas_id_vehiculo"] = ordas_id_vehiculo;
    return this.http
      .get("/api/insurances/ordas", options)
      .pipe(tap((_) => console.log("OrdasService.getInsurances: Ok")));
  }

  public getUnitInsurances(unit, vehicle_condition, price, term, zip_code, product, model_id): Observable<any> {
    const options = {
      params: {
        unit: JSON.stringify(unit),
        new_or_used: vehicle_condition,
        price: price,
        term: term || undefined,
        zip_code: zip_code,
        product: product,
        nexu_model_id: model_id,
      },
    };

    return this.http
      .get("/api/insurances/unit", options)
      .pipe(tap((_) => console.log("OrdasService.getUnitInsurances: Ok")));
  }

  public getInsuranceEstimated(is_new, price): Observable<any> {
    const options = {
      params: {
        new_or_used: is_new ? "auto_nuevo" : "auto_usado",
        price: price,
      },
    };
    return this.http
      .get("/api/insurances/estimated", options)
      .pipe(tap((_) => console.log("OrdasService.getInsuranceEstimated: Ok")));
  }

  public emitPolicy({
    product,
    iCveAseguradora,
    iCveProducto,
    iCveTipoPersona,
    iCveTipoVenta,
    iPersona_ID = undefined,
    sCodPostal,
    sIdCotizacionAse,
    sNumSerie,
    CotizacionId,
    sRFCAsegurado,
    sRFCConductor,
    apMaternoTitular = undefined,
    apPaternoTitular = undefined,
    cvv = undefined,
    fechaVencimientoAnio_Tarjeta = undefined,
    fechaVencimientoMes_Tarjeta = undefined,
    iCveRegimenFiscal = undefined,
    iCveRegimenSocietario = undefined,
    iRequiereFactura = undefined,
    nombreTitular = undefined,
    numtarjeta = undefined,
    sAMaternoAsegurado = undefined,
    sAMaternoConductor = undefined,
    sAPaternoAsegurado = undefined,
    sAPaternoConductor = undefined,
    sActObjSocial = undefined,
    sApoderadoLegal = undefined,
    sCalle = undefined,
    sCelular = undefined,
    sCodPostalFiscal = undefined,
    sContratoFinan = undefined,
    sCveGeneroAsegurado = undefined,
    sCveGeneroConductor = undefined,
    sCveGiroAse = undefined,
    sEmailAsegurado = undefined,
    sEmailColaborador = undefined,
    sEmailConductor = undefined,
    sExtension = undefined,
    sFax = undefined,
    sFecConstAsegurado = undefined,
    sFecFinFinanciamiento = undefined,
    sFecFinVigencia = undefined,
    sFecInicioFinanciamiento = undefined,
    sFecInicioVigencia = undefined,
    sFecNacAsegurado = undefined,
    sFecNacConductor = undefined,
    sFolioMercantil = undefined,
    sNombreAsegurado = undefined,
    sNombreConductor = undefined,
    sNumExterior = undefined,
    sNumInterior = undefined,
    sNumMotor = undefined,
    sNumPlacas = undefined,
    sNumPolizaAnt = undefined,
    sRFCFactura = undefined,
    sRazonSocialAsegurado = undefined,
    sRazonSocialFactura = undefined,
    sTelefono = undefined,
    iCveEdocCivil = undefined,
    sLada = undefined,
    sUsoCFDI = undefined,
  }): Observable<any> {
    const options = {
      params: {
        product,
        iCveAseguradora,
        iCveEdocCivil,
        iCveProducto,
        iCveTipoPersona,
        iCveTipoVenta,
        iPersona_ID,
        sCodPostal,
        sIdCotizacionAse,
        sNumSerie,
        CotizacionId,
        apMaternoTitular,
        apPaternoTitular,
        cvv,
        fechaVencimientoAnio_Tarjeta,
        fechaVencimientoMes_Tarjeta,
        iCveRegimenFiscal,
        iCveRegimenSocietario,
        iRequiereFactura,
        nombreTitular,
        numtarjeta,
        sAMaternoAsegurado,
        sAMaternoConductor,
        sAPaternoAsegurado,
        sAPaternoConductor,
        sActObjSocial,
        sApoderadoLegal,
        sCalle,
        sCelular,
        sCodPostalFiscal,
        sContratoFinan,
        sCveGeneroAsegurado,
        sCveGeneroConductor,
        sCveGiroAse,
        sEmailAsegurado,
        sEmailColaborador,
        sEmailConductor,
        sExtension,
        sFax,
        sFecConstAsegurado,
        sFecFinFinanciamiento,
        sFecFinVigencia,
        sFecInicioFinanciamiento,
        sFecInicioVigencia,
        sFecNacAsegurado,
        sFecNacConductor,
        sFolioMercantil,
        sNombreAsegurado,
        sNombreConductor,
        sNumExterior,
        sNumInterior,
        sNumMotor,
        sNumPlacas,
        sNumPolizaAnt,
        sRFCAsegurado,
        sRFCConductor,
        sRFCFactura,
        sRazonSocialAsegurado,
        sRazonSocialFactura,
        sTelefono,
        sLada,
        sUsoCFDI,
      },
    };
    return this.http
      .get("/api/insurances/emision", options)
      .pipe(tap((_) => console.log("OrdasService.emitPolicy: Ok")));
  }

  public printPolicy({ clave_control = "1", clave_aseguradora, numero_poliza }) {
    const options = {
      params: {
        iCveControl: clave_control,
        iCveAse: clave_aseguradora,
        sNumPolizaAse: numero_poliza,
      },
    };
    return this.http
      .get("/api/insurances/print_policy", options)
      .pipe(tap((_) => console.log("OrdasService.printPolicy: Ok")));
  }
}
